import { i18n } from "@tellescope/i18n";
import { ContactDetailsBlockType } from "../../../types";

/**
 * The recommended starting configurations offered by the customize helper. Titles and descriptions
 * are getters so the literals stay inside a static `t()` call for extraction while still resolving
 * at render time.
 */
export const CUSTOMIZE_HELPER_TEMPLATES: {
  key: string;
  getTitle: () => string;
  getDescription: () => string;
  blockTypes: ContactDetailsBlockType[];
}[] = [
  {
    key: "patient-information",
    getTitle: () => i18n.t("Patient overview", { ns: "contacts" }),
    getDescription: () => i18n.t("All you need to get started", { ns: "contacts" }),
    blockTypes: ["timeline.ai-summary", "information.tags", "information.fields", "timeline.timeline"],
  },
  {
    key: "recent-activity",
    getTitle: () => i18n.t("Recent activity", { ns: "contacts" }),
    getDescription: () => i18n.t("The latest from your patients", { ns: "contacts" }),
    blockTypes: ["timeline.ai-summary", "timeline.timeline"],
  },
  {
    key: "clinical",
    getTitle: () => i18n.t("Clinical", { ns: "contacts" }),
    getDescription: () => i18n.t("Clinical care overview", { ns: "contacts" }),
    blockTypes: [
      "timeline.ai-summary",
      "information.tags",
      "information.fields",
      "information.care-team",
      "calendar.calendar",
      "eligibility.eligibility",
      "medications.medications",
    ],
  },
];
